import { Pressable, Text as RNText, View } from 'react-native';

import { Text } from '@/components/ui/Text';

export interface PresenceToastContent {
  message: string;
  /** The override affordance, e.g. "Edit anyway" / "Delete anyway". */
  actionLabel: string;
}

/**
 * The blocked-tap toast: names who holds the focus claim and offers the
 * explicit override (CONTEXT.md: Override). Floats above the screen's bottom
 * actions; the parent owns timing (auto-dismiss) and what the action does.
 */
export function PresenceToast({
  toast,
  onAction,
  onDismiss,
}: {
  toast: PresenceToastContent | null;
  onAction: () => void;
  onDismiss: () => void;
}) {
  if (!toast) return null;
  return (
    <View
      pointerEvents="box-none"
      className="absolute inset-x-0 bottom-24 items-center px-5"
    >
      <View className="max-w-96 flex-row items-center gap-3 rounded-xl bg-ink px-4 py-3 shadow-lg">
        <Text variant="caption" className="shrink text-on-ink">
          {toast.message}
        </Text>
        <Pressable onPress={onAction} hitSlop={6}>
          <RNText className="font-sans-semibold text-sm text-caution">
            {toast.actionLabel}
          </RNText>
        </Pressable>
        <Pressable onPress={onDismiss} hitSlop={8} accessibilityLabel="Dismiss">
          <RNText className="text-sm text-on-ink opacity-60">✕</RNText>
        </Pressable>
      </View>
    </View>
  );
}
